import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex';
import * as accountTypes from '@account/store/types'
import api from '@board/api'

import BoardWrite from '@board/components/board/BoardWrite.vue'
import BoardMain from '@board/components/board/BoardMain.vue';

@Component({    
    components: {        
        BoardWrite,
        BoardMain
    },

    computed: mapGetters({
        user: accountTypes.USER,
        current: accountTypes.CURRENT
    })
})
export default class BoardWritePage extends Vue {
    user!: account.User;
    current!: account.TCurrent;
    
    permissionMounted: boolean = false;
    adminPermission: boolean = false;
    
    async created() {
        var { SYSID, MENUID } = this.$route.query;
        
        await this.mountPermission(Number(SYSID), Number(MENUID)).then(res => {
            this.adminPermission = res;   
            this.permissionMounted = true;  
            console.log('permissionMounted', this.permissionMounted)  
        })
    }

    mountPermission(boardId: number, menuId: number): Promise<boolean> {                
        return Promise.all([
            api.board.getBoardManagers(boardId),
            api.board.getBoardPermission(boardId)
        ]).then(res => {
            var boardManages = res[0] as board.BoardManager[];
            var boardPermission = res[1] as board.BoardPermission;

            var menuAdmin: boolean = this.current.permissions.menues.findIndex(m => m.id == menuId && m.manager) >= 0;
            var boardAdmin: boolean = boardManages.findIndex(m => m.manager === this.user.personCode) >= 0;
            var readPermission: boolean = boardPermission.roleName !== 'Default' && boardPermission.read;            

            return menuAdmin || boardAdmin || readPermission;
        });           
    }

    getComponent() {
        return this.adminPermission ? BoardMain : BoardWrite;
    }

    onSubmitClick() {
        (this.$refs.refWrite as any).onSubmitClick(false, false).then(async () => {
            await (window as any).alertAsync(this.$t('등록되었습니다'));
            this.$router.go(0);
        });
    }
}